<script>
import Swal from "sweetalert2";
import CKEditor from "@ckeditor/ckeditor5-vue";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import NewsApi from "@/services/news-api";
import ArticleApi from "@/services/article-api";

/**
 * Contacts-grid component
 */
export default {
  page: {
    title: "Actualités et Articles",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, ckeditor: CKEditor.component },

  data() {
    return {
      role: null,
      showModal: false,
      showArticle:false,
      newsList: [],
      articleList: [],
      selected: { id: null, date: null, text: null, title: null, body: null },
      editor: ClassicEditor,
      readMoreActivated:false,
      activatedArticle:null,
      pagemodelMainNews: {currentPage : 1, perPage : 6, totalRows: 0},
      pagemodelMainArticle: {currentPage : 1, perPage : 3, totalRows: 0},
      isNewsListBusy:false,
      isArticleListBusy:false,
      showAddnews:false
    };
  },

  mounted() {
    this.role = sessionStorage.getItem("userr");
    this.findNews();
    this.findArticle();

  },

  methods: {
    findNews() {
      this.isNewsListBusy = true;
      NewsApi.getNews(this.pagemodelMainNews.currentPage, this.pagemodelMainNews.perPage,null).then((result) => {
        
        this.newsList = result.list;
        this.pagemodelMainNews.totalRows = result.total;
        this.pagemodelMainNews.currentPage = result.page;
        this.pagemodelMainNews.perPage = result.pageSize;
        this.pagemodelMainNews.pageSize = result.pageSize;
      }).finally(() => {
        this.isNewsListBusy = false;
      })
      ;
    },

    activateReadMore(article){
        this.readMoreActivated = true;
        this.activatedArticle=article;
        this.showArticle = true;
    },

    addNews() {
      this.showAddnews = true;
      this.selected.id = null;
      this.selected.date = null;
      this.selected.text = null;
    },

    editNews(news){
      this.showAddnews = true;
      this.selected.id=news.id;
      this.selected.date = news.date;
      this.selected.text = news.text;
    },

    saveNews() {
      NewsApi.saveNews(this.selected).then((result) => {
        if (result) {
          this.findNews();
          this.showAddnews = false;
        }
      });
    },

    removeNews(news) {
      Swal.fire({
        title: "Supprimer l'Actualité",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        cancelButtonText: "Annuler",
        confirmButtonText: "Oui, supprimer!",
      }).then((result) => {
        if (result.value) {
          NewsApi.removeNews(news.id).then(() => {
            this.findNews();
          });
        }
      });
    },

    findArticle() {
      this.isArticleListBusy=true;
      ArticleApi.getArticle(this.pagemodelMainArticle.currentPage, this.pagemodelMainArticle.perPage).then((result) => {
        this.articleList = result.list;
        this.articleList = result.list;
        this.pagemodelMainArticle.totalRows = result.total;
        this.pagemodelMainArticle.currentPage = result.page;
        this.pagemodelMainArticle.perPage = result.pageSize;
        this.pagemodelMainArticle.pageSize = result.pageSize;
        
      }).finally(() => {
        this.isArticleListBusy = false;
      })
      ;
    },

    addArticle() {
      this.showModal = true;
      this.selected.id = null;
      this.selected.title = null;
      this.selected.body = null;
    },

    editArticle(article){
      this.showModal = true;
      this.selected.id = article.id;
      this.selected.title = article.title;
      this.selected.body = article.body;
    },

    saveArticle() {
      ArticleApi.saveArticle(this.selected).then((result) => {
        if (result) {
          this.findArticle();
          this.showModal = false;
        }
      });
    },

    removeArticle(article) {
      Swal.fire({
        title: "Supprimer l'Article",
        html: article.title,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        cancelButtonText: "Annuler",
        confirmButtonText: "Oui, supprimer!",
      }).then((result) => {
        if (result.value) {
          ArticleApi.removeArticle(article.id).then(() => {
            this.findArticle();
          });
        }
      });
    },
  },
};
</script>

<template>
  <Layout>
    <div class="row pt-4 pb-4">
      <div :class="role == 1 ? 'col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12' : 'col-xl-6 col-lg-12 col-md-12 col-sm-12 col-xs-12'"  class="pb-4">
        <div class="card mr-2 pt-2 h-100 border border-primary" >
          <div class="card-body">
            <div class="row">
              <div class="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-xs-12 float-left">
                <h4 class="card-title text-primary" style="font-size: 25px">
              Actualités et Faits marquants
            </h4>
              </div>
              <div class="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-xs-12 float-right">
                <b-button
                  v-if="role == 1 || role ==2"
                  variant="primary"
                  @click="addNews()"
                  class="float-right"
                >
                  <i
                    class="fas fa-plus-square font-size-18 font-weight-bold align-middle mr-2"
                  ></i>
                  <span class="font-weight-bold"> Nouvelle Actualité </span>
                </b-button>
              </div>
            </div>
            
            
            <p class="card-title-desc pb-3">
              Actualités, évènements et faits marquants du {{role==1 ? 'fournisseur.'  : 'groupement pharmaceutiques.'}} 
            </p>

            <ul class="verti-timeline list-unstyled" >
              <li v-for="data in newsList" :key="data.id" class="event-list">
                <div class="event-timeline-dot">
                  <i class="bx bx-right-arrow-circle font-size-18"></i>
                </div>
                <div class="media">
                  <div class="mr-3">
                    <h5 class="font-size-12">
                      {{ data.formatedDate }}
                      <i
                        class="bx bx-right-arrow-alt font-size-16 text-primary align-middle ml-2"
                      ></i>
                    </h5>
                  </div>
                  <div class="media-body">
                    {{ data.text }}
                  </div>
                  <div class="mr-2" v-if="role == 1 || role==2">
                    <a
                      title="Modifier"
                      @click="editNews(data);
                        
                        showAddnews = true;
                      "
                      class="action-icon text-warning"
                      style="cursor: pointer"
                    >
                      <i class="mdi mdi-pencil font-size-22"></i>
                    </a>
                  </div>

                  <div class="ml-2" v-if="role == 1 || role==2">
                    <a
                      title="Supprimer"
                      @click="removeNews(data)"
                      :class="data.id ? '' : 'd-none'"
                      class="action-icon text-danger"
                      style="cursor: pointer"
                    >
                      <i class="mdi mdi-trash-can font-size-22"></i>
                    </a>
                  </div>
                </div>
              </li>
              <div v-if="isNewsListBusy" class="d-flex justify-content-center">
                        <div class="spinner-border text-success" role="status">
                            <span class=" sr-only">Chargement...</span>
                        </div>
                </div>
                <span v-if="!isNewsListBusy && !newsList.length" class="d-flex justify-content-center m-4 text-danger" >Aucune Actualité dans la liste</span>
            </ul>
          </div>
          <div class="card-footer bg-transparent">
            <div class="text-center mt-4">
              <!-- Pagination -->
                  <div class="dataTables_paginate paging_simple_numbers float-right">
                    <ul class="pagination pagination-rounded mb-0">
                      <b-pagination v-model="pagemodelMainNews.currentPage" :disabled="isNewsListBusy" :per-page="pagemodelMainNews.pageSize" :total-rows="pagemodelMainNews.totalRows" @input="findNews()" ></b-pagination>
                    </ul>
                  </div>
              <!-- Fin Pagination  -->
            </div>
          </div>
        </div>
      </div>

      <div v-if="role !=1" :class="role == 1 ? 'col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12' : 'col-xl-6 col-lg-12 col-md-12 col-sm-12 col-xs-12' " class="pb-4">
        <div class="card border border-primary mr-2 pt-2 h-100" >
          <div class="card-body">
            <div class="row">
              <div class="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-xs-12 float-left">
                <h4 class="card-title text-primary" style="font-size: 25px">
                  Articles scientifiques
                </h4>
              </div>
              <div class="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <b-button
                  v-if="role == 2"
                  variant="primary"
                  @click="addArticle()"
                  class="float-right"
                >
                  <i
                    class="fas fa-plus-square font-size-18 font-weight-bold align-middle mr-2"
                  ></i>
                  <span class="font-weight-bold"> Nouvel Article </span>
                </b-button>
              </div>
            </div>

            <div v-for="data in articleList" :key="data.id" class="event-list">
              <div class="text-muted pt-4">
                <div class="row mt-3">
                  <div :class="role == 2 ? 'col-10' : 'col-12' ">
                    <p
                      class="mb-1  text-info font-weight-bold font-size-18"
                    >
                      <i
                        class="mdi mdi-circle-medium align-middle text-primary mr-1"
                      ></i>
                      {{ data.title }}
                    </p>
                  </div>
                  <div v-if="role == 2" class="col-2 pr-4">
                   
                    <a
                      title="Supprimer"
                      @click="removeArticle(data)"
                      :class="data.id ? '' : 'd-none'"
                      class="action-icon text-danger float-right"
                      style="cursor: pointer"
                    >
                      <i class="mdi mdi-trash-can font-size-22"></i>
                    </a>
                     <a
                      title="Modifier"
                      @click="
                        editArticle(data)  
                        showModal = true;
                      "
                      class="action-icon text-warning float-right"
                      style="cursor: pointer"
                    >
                      <i class="mdi mdi-pencil font-size-22 "></i>
                    </a>
                  </div>
                </div>

                   <div >
                    <span >
                      <p style=" height: 4em; display: -webkit-box; overflow: hidden;"
                        v-html="data.body.slice(0,300)"
                        class=" text-muted pl-4 pr-4 text-justify"
                        ></p> 
                    </span>
                    <a class="ml-4"  @click="activateReadMore(data)" href="#">
                        Voir Plus...
                    </a>
                  </div>


              </div>
              
            </div>
            <div v-if="isArticleListBusy" class="d-flex justify-content-center">
                        <div class="spinner-border text-success" role="status">
                            <span class=" sr-only">Chargement...</span>
                        </div>
              </div>
              <span v-if="!isArticleListBusy && !articleList.length" class="d-flex justify-content-center m-4 text-danger" >Aucun Article dans la liste</span>
          </div>

          <div class="card-footer bg-transparent">
            <div class="text-center mt-2">
                   <!-- Pagination -->
                            <div class="dataTables_paginate paging_simple_numbers float-right">
                                <ul class="pagination pagination-rounded mb-0">
                                <b-pagination v-model="pagemodelMainArticle.currentPage" :disabled="isArticleListBusy" :per-page="pagemodelMainArticle.pageSize" :total-rows="pagemodelMainArticle.totalRows" @input="findArticle()" ></b-pagination>
                                </ul>
                            </div>
                    <!-- Fin Pagination  -->
            </div>
          </div>
        </div>
      </div>
    </div>


<b-modal
      v-if="activatedArticle"
      v-model="showArticle"
      :title="activatedArticle.title"
      centered
      title-class="text-warning"
      title-tag="h5"
      header-close-variant="danger" 
      size="xl"
      scrollable
    >
        <span class="zoom-container" >
            <p 
              v-html="activatedArticle.body"
              class=" text-muted pl-4 pr-4 text-justify"
              ></p>
            </span>

     <template v-slot:modal-footer>
        <b-button class="zoom-container" variant="secondary" @click="showArticle = false" size="md"
          >Fermer</b-button
        >
      </template>
</b-modal>

    <b-modal
      v-model="showModal"
      :title= "selected.id==null ?  'Ajouter un Article' : 'Modifier l\'article' "
      centered
      title-class="text-warning"
      title-tag="h5"
      header-close-variant="danger"
      size="xl"
      v-if="role == 2"
    >
    <div class="zoom-container">
      <form class="needs-validation">
        <div  class="form-group row mb-3 ml-4">
          <label class="col-md-3 col-form-label font-size-14"
            >Titre d'Article</label
          >
          <div class="col-md-9">
            <input
              type="text"
              class="form-control font-size-13"
              v-model="selected.title"
            />
          </div>
        </div>

        <div  class="form-group row mb-3 ml-4">
          <label class="col-md-3 col-form-label font-size-14"
            >Contenu d'Article</label
          >
          <div class="col-md-9">
            <ckeditor v-model="selected.body" :editor="editor"></ckeditor>
          </div>
        </div>
      </form>
    </div>
      <template v-slot:modal-footer>
        <b-button class="zoom-container" variant="secondary" @click="showModal = false" size="md"
          >Annuler</b-button
        >
        <b-button
        class="zoom-container"
          variant="primary"
          @click="saveArticle()"
          size="md"
          >Enregistrer</b-button
        >
      </template>
    </b-modal>

    <b-modal
      v-model="showAddnews"
      title= "Ajouter une Actualité"
      centered
      title-class="text-warning"
      title-tag="h5"
      header-close-variant="danger"
      size="xl"
      v-if="role==2 || role==1"
    >
    <div class="zoom-container">
      <form class="needs-validation">
        <div  class="form-group row mb-3 ml-4">
          <label class="col-md-3 col-form-label font-size-14"
            >Date d'Actualié</label
          >
          <div class="col-md-9">
            <b-form-datepicker
              v-model="selected.date"
              right
              locale="fr"
              label-no-date-selected="Date d'Actualié"
              dark
            ></b-form-datepicker>
          </div>
        </div>

        <div  class="form-group row mb-3 ml-4">
          <label class="col-md-3 col-form-label font-size-14"
            >Description d'Actualité</label
          >
          <div class="col-md-9">
            <textarea
              v-model="selected.text"
              class="form-control"
              :maxlength="255"
              rows="3"
              placeholder="La Description ne doit pas dépasser 255 caractères."
            ></textarea>
            <div class="text-center">
              <p
                v-if="selected.text"
                class="badge position-absolute"
                :class="{
                  'badge-success': selected.text.length !== 255,
                  'badge-danger': selected.text.length === 255,
                }"
              >
                {{ selected.text.length }} / 255
              </p>
            </div>
          </div>
        </div>
      </form>
    </div>
      <template v-slot:modal-footer>
        <b-button class="zoom-container" variant="secondary" @click="showAddnews = false" size="md"
          >Annuler</b-button
        >
        <b-button
        class="zoom-container"
          variant="primary"
          @click=" saveNews()"
          size="md"
          >Enregistrer</b-button
        >
      </template>
    </b-modal>

    







  </Layout>
</template>

<style >
.truncate-title {
  white-space: nowrap;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>